import React from 'react'
import { componentDidMount } from '../../../components/Lifecycles'
import { compose } from 'ramda'

const view = ({
  component: Component,
  onLoad,
  ...props
}) =>
  <Component { ...props } />

// didMount :: Props -> Action OBSERVE
const didMount = ({ onLoad }) => onLoad()

export default compose(
  componentDidMount(didMount, true),
)(view)
